import React from 'react'

const About = () => {
  return (
    <div className='container mt-5 pt-5'>
      <div class="container mt-3" data-aos="fade-up" data-aos-delay="500">
        <div className='section-title choose-gleamdesk'>
          <p>About GleamDesk</p>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <div>
              <img src="assets/img/about.png" className='img-fluid img-about' alt="" />
            </div>
          </div>
          <div class="col-lg-6">
            <div class="mt-4 fs-17 fw-500">
              <p>
                At <strong>GLEAMDESK</strong>, we believe investing should be rewarding in more ways than one. As a trusted <strong>sub-broker partnered with Motilal Oswal Group</strong>, we bring you a wide range of financial products designed to help you grow, diversify, and secure your wealth.
              </p>
            </div>

            <div class="mt-4 fs-17 fw-500">
              <div className='fw-600 fs-20 mb-1'> Who we are ? </div>
              <p><strong>GLEAMDESK</strong> is more than just a financial services provider—we are your partner in building a brighter financial future. Backed by the expertise and credibility of Motilal Oswal, we combine strong market insights with innovative client-focused solutions.</p>
            </div>
          </div>
        </div>
      </div>

      {/* <div className='mt-5 mb-5' data-aos="fade-up" data-aos-delay="500">
        <div className='section-title'>
          <p>Core values</p>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="mb-3">
              <div class="card-size">
                <i class="fa fa-circle mr-2 ml-2"></i>
                <span>Integrity &amp; transparency</span>
              </div>
            </div>
            <div class="mb-3">
              <div class="card-size">
                <i class="fa fa-circle mr-2 ml-2"></i>
                <span>
                  Quality Investment Solutions based on Unbiased Research
                </span>
              </div>
            </div>
            <div class="mb-3">
              <div class="card-size">
                <i class="fa fa-circle mr-2 ml-2"></i>
                <span>Personalisede Service</span>
              </div>
            </div>
            <div class="mb-3">
              <div class="card-size">
                <i class="fa fa-circle mr-2 ml-2"></i>
                <span>Monthly P/L</span>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="mb-3">
              <div class="card-size">
                <i class="fa fa-circle mr-2 ml-2"></i>
                <span>Encourage growth &amp; Investment Learning</span>
              </div>
            </div>
            <div class="mb-3">
              <div class="card-size">
                <i class="fa fa-circle mr-2 ml-2"></i>
                <span>Crystalline Communication</span>
              </div>
            </div>
            <div class="mb-3">
              <div class="card-size">
                <i class="fa fa-circle mr-2 ml-2"></i>
                <span>Comprehensive &amp; Customized Financial Services</span>
              </div>
            </div>
            <div class="mb-3">
              <div class="card-size">
                <i class="fa fa-circle mr-2 ml-2"></i>
                <span>Weekly portfolio performance</span>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      <div className='mt-5 mb-5' data-aos="fade-up" data-aos-delay="500">
        <div className='section-title'>
          <p>What We Offer</p>
          <div className='fs-20 fw-500'>We deliver a comprehensive suite of investment opportunities, including</div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="mb-3">
              <div class="card-size">
                <i class="fa fa-circle mr-2 ml-2"></i>
                <span>Stocks & Equity Trading</span>
              </div>
            </div>
            <div class="mb-3">
              <div class="card-size">
                <i class="fa fa-circle mr-2 ml-2"></i>
                <span>Mutual Funds</span>
              </div>
            </div>
            <div class="mb-3">
              <div class="card-size">
                <i class="fa fa-circle mr-2 ml-2"></i>
                <span>Bonds & Fixed Income Products</span>
              </div>
            </div>
            <div class="mb-3">
              <div class="card-size">
                <i class="fa fa-circle mr-2 ml-2"></i>
                <span>Portfolio Management Services (PMS)</span>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="mb-3">
              <div class="card-size">
                <i class="fa fa-circle mr-2 ml-2"></i>
                <span>Alternative Investment Funds (AIF)</span>
              </div>
            </div>
            <div class="mb-3">
              <div class="card-size">
                <i class="fa fa-circle mr-2 ml-2"></i>
                <span>Unlisted Shares</span>
              </div>
            </div>
            <div class="mb-3">
              <div class="card-size">
                <i class="fa fa-circle mr-2 ml-2"></i>
                <span>Comprehensive &amp; Customized Financial Services</span>
              </div>
            </div>
            <div class="mb-3">
              <div class="card-size">
                <i class="fa fa-circle mr-2 ml-2"></i>
                <span>Many more tailored financial solutions</span>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div className='mt-5 mb-5' data-aos="fade-up" data-aos-delay="500">
        <div className='section-title choose-gleamdesk'>
          <p>Our Unique Advantage</p>
        </div>
        <div className='ml-5'>
          <div>🎉 What sets GLEAMDESK apart is our exclusive rewards program.</div>
          <div>🎉 Every time you open a DEMAT account with us and start investing, you earn reward points.</div>
          <div>🎉 These points add extra value to your investment journey, making your financial growth not just profitable but also rewarding.</div>
        </div>
      </div>

      <div className='mt-5 mb-5' data-aos="fade-up" data-aos-delay="500">
        <div className='section-title choose-gleamdesk'>
          <p>Our Mission</p>
        </div>
        <div></div>
        <div className='text-center fw-500'>
          Empower you with smart investment choices while making the process engaging and rewarding
        </div>
      </div>

      <div className='mt-5 mb-5' data-aos="fade-up" data-aos-delay="500">
        <div className='section-title choose-gleamdesk'>
          <p>Why Choose Us</p>
        </div>
        <div className='fw-500 ml-5'>
          <div className='ml-1'>
            <div className='mb-1'>
              <span className='mx-2'>✅</span>
              Strong partnership with Motilal Oswal Group
            </div>
            <div className='mb-1'>
              <span className='mx-2'>✅</span>
              Wide range of financial products under one roof
            </div>
            <div className='mb-1'>
              <span className='mx-2'>✅</span>
              Transparent, cdivent-first approach
            </div>
            <div className='mb-1'>
              <span className='mx-2'>✅</span>
              Unique reward points system for investors
            </div>
            <div className='mb-1'>
              <span className='mx-2'>✅</span>
              Dedicated support to guide you at every step
            </div>
          </div>

        </div>
      </div>

      <div className='mt-5 mb-5' data-aos="fade-up" data-aos-delay="500">
        <div className='section-title choose-gleamdesk'>
          <p>Supports from GleamDesk</p>
        </div>

        <div class="row">
          <div class="col-md-6 col-lg-3">
            <div class="box aos-init aos-animate mt-4" data-aos="zoom-fade-out" data-aos-duration="2000">
              <div class="img-box img-box-color">
                <img src="assets/img/about/drm.png" alt="" style={{ width: 100, height: 'auto' }} />
              </div>
              <div class="detail-box">
                <h5 className='fw-700'>
                  Dedicated Relationship Managers
                </h5>
                <p>
                  To guide you with any of your Demat &amp; Trading account related queries, our enthusiast team of
                  Relationship Managers is always on the other side of yours telephone.
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-3 ">
            <div class="box aos-init aos-animate mt-4" data-aos="fade-zoom-out" data-aos-duration="1000">
              <div class="img-box img-box-color">
                <img src="assets/img/about/pms.png" alt="" style={{ width: 100, height: 'auto' }} />
              </div>
              <div class="detail-box">
                <h5 className='fw-700'>
                  Portfolio Management Service
                </h5>
                <p>
                  Managing your portfolio by yourself when you are busy building your future or having less knowledge at
                  times lacks to get a positive portfolio. Therefore, here at Findesk we care about your time and
                  Investments.
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-3 ">
            <div class="box aos-init aos-animate mt-4" data-aos="fade-zoom-out" data-aos-duration="1500">
              <div class="img-box img-box-color">
                <img src="assets/img/about/help-desk.png" alt="" style={{ width: 150, height: 'auto' }} />
              </div>
              <div class="detail-box">
                <h5 className='fw-700'>
                  Cetralized Help Desk
                </h5>
                <p>
                  To deliver you quick services with regard to trade understanding or on the technical side, the term at
                  Findesk is always availbale to get you through.
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-3 ">
            <div class="box aos-init aos-animate mt-4" data-aos="fade-zoom-out" data-aos-duration="2000">
              <div class="img-box img-box-color">
                <img src="assets/img/about/call-support.png" alt="" style={{ width: 150, height: 'auto' }} />
              </div>
              <div class="detail-box">
                <h5 className='fw-700'>
                  Call Support
                </h5>
                <p>
                  You can also opt for call for support with out team that is basically set to resolve any of your
                  queries.
                </p>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>
  )
}

export default About